<div mat-dialog-title class="lv-dialog-header lv-external-resource-dialog-header-margin">
  <div class="lv-dialog-header-title">
    {{header}}
  </div>
  <div class="lv-dialog-icon-close">
    <mat-icon [svgIcon]="'Times'" (click)="closeDialog()"></mat-icon>
  </div>
</div>

<div mat-dialog-content class="lv-external-resource-dialog-content">
  <iframe *ngIf="!isPdf" class="lv-external-resource-dialog-iframe" [src]="srcUrl"></iframe>
  <ng-container *ngIf="isPdf">
    <mat-progress-bar *ngIf="loading" mode="indeterminate" color="accent"></mat-progress-bar>
    <lv-document-viewer style="width: 100%;height: 90%"
                        [document]="pdfDocument$ | async"
                        (documentRenderedSuccessfully)="onDocumentViewerSuccessful($event)"
                        (executeAction)="executeAction($event)"
                        [hideSpinner]="true"
                        [hideCustomActions]="false"
                        [hidePager]="true"
                        [hideRotation]="true"
                        [actions]="actions"
    >
    </lv-document-viewer>
  </ng-container>
</div>

<div mat-dialog-actions class="lv-external-resource-dialog-footer">
  <button mat-stroked-button [loading]="false" (click)="closeDialog()">
    {{'INFO_DIALOG.CLOSE' | translate}}
  </button>
</div>
